<template>
  <header class="event-detail-header relative lg:row-start-1 lg:row-end-2 pt-16 xl:pt-0 w-full overflow-hidden grid grid-cols-12 lg:block">
    <AtomBrandLyreBackgroundThemed
      :svg-theme="lyreTheme"
      class="event-detail-header-svg col-span-12 row-start-1 row-end-4 md:row-end-3 width-lyre absolute bottom-0 pointer-events-none"
    />
    <section
      class="group relative col-span-12 row-start-1 row-end-2 mx-4 lg:mx-8 xl:mx-24 2xl:mx-[8vw] overflow-hidden rounded-2xl lg:rounded-2xl xl:rounded-t-none xl:rounded-b-2xl"
    >
      <div class="relative w-full h-[41.9vw] 2xl:max-h-[36.1vw]">
        <MoleculePicture ref="imageMoleculeRef" class="block w-full h-full object-cover" :image="image" :alt="imageAlt" />
        <p
          v-if="image && image.copyright"
          class="event-detail-header-image-copyright hidden xl:block opacity-0 group-hover:opacity-100 absolute right-0 bottom-0 bg-black/75 rounded-tl-2xl text-white text-xs leading-none px-3 py-2 transform transition duration-200"
        >
          {{ image.copyright }}
        </p>
      </div>
    </section>

    <div class="lg:hidden col-span-12 md:col-span-9 event-detail-header-mobile-text-container px-8 sm:px-12 pt-6 relative z-10">
      <MoleculeEventDetailPageAudioV2 class="mb-2" :audio-work="audioWork" :toggle-header-audio="toggleHeaderAudio" />

      <p class="leading-tight font-semibold text-3xl" :class="theme && `t-cdp-title-v2-${theme}`">{{ title }}</p>
    </div>
  </header>
</template>

<script setup lang="ts">
const props = defineProps({
  title: { type: String, required: false, default: undefined },
  image: { type: Object as PropType<Record<string, any>>, required: false, default: undefined },
  imageAlt: { type: String, required: false, default: undefined },
  audioWorks: { type: Array as PropType<any[]>, required: false, default: () => [] },
  theme: { type: String, required: false, default: undefined },
  headerAudioIsPlaying: { type: Boolean, required: true },
  toggleHeaderAudio: { type: Function, required: true },
})

const audioWork =
  props.audioWorks?.slice().find(({ audio, mainFragment }) => audio?.url && mainFragment) ||
  props.audioWorks
    ?.slice()
    .reverse()
    .find(({ audio }) => audio?.url) ||
  {}
const isMobile = ref(false)
const checkScreen = () => {
  isMobile.value = window.innerWidth < 1024
}
onMounted(() => {
  checkScreen()
  window.addEventListener('resize', checkScreen)
})
const lyreTheme = computed(() => {
  if (props.theme === 'purple' && isMobile.value) {
    return 'purple-mobile'
  }
  return props.theme
})
</script>

<style lang="scss" scoped>
// Other than on small screens where the header size grows with the content,
// you want the header to get a set height on the larger screens.
.event-detail-header {
  @screen lg {
    height: 80vw;
    margin-bottom: -35vw;
  }

  @screen xl {
    height: 63vw;
    margin-bottom: -30vw;
  }

  @screen 2xl {
    height: 58vw;
    margin-bottom: -30vw;
  }
}

// The lyre shape with the gradient in the background has this relative size on al breakpoints.
.width-lyre {
  width: 200vw;
  left: -80vw;
}

.event-detail-header-mobile-text-container {
  padding-bottom: 18vw;

  @screen lg {
    padding-bottom: 10vw;
  }
}

.event-detail-header-svg {
  z-index: -1; // because the image needs to have position lg:static in order to keep the copyright in its place when you hover on the image
}

.event-detail-header-image-copyright {
  @screen xl {
    margin-bottom: 8.9vw;
  }

  @screen 2xl {
    margin-bottom: 8.1vw;
  }
}
</style>
